"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDot = void 0;
var react_1 = __importDefault(require("react"));
var shapes_1 = require("./shapes");
function CustomDot(props) {
    return props.cx && props.cy && react_1.default.createElement(Shape, __assign({}, props));
}
exports.CustomDot = CustomDot;
var Shape = function (props) {
    var shape = props.shape, rest = __rest(props, ["shape"]);
    switch (shape) {
        case 'square': {
            return react_1.default.createElement(shapes_1.Square, __assign({}, rest));
        }
        case 'rect': {
            return react_1.default.createElement(shapes_1.Rectangle, __assign({}, rest));
        }
        case 'triangle': {
            return react_1.default.createElement(shapes_1.Triangle, __assign({}, rest));
        }
        case 'diamond': {
            return react_1.default.createElement(shapes_1.Diamond, __assign({}, rest));
        }
        case 'cross': {
            return react_1.default.createElement(shapes_1.Cross, __assign({}, rest));
        }
        case 'star': {
            return react_1.default.createElement(shapes_1.Star, __assign({}, rest));
        }
        case 'happy': {
            return react_1.default.createElement(shapes_1.Happy, __assign({}, rest));
        }
        default: {
            return react_1.default.createElement(shapes_1.Circle, __assign({}, rest));
        }
    }
};
//# sourceMappingURL=CustomDot.js.map